import { FormlyFieldConfig } from "@ngx-formly/core";
import { map } from "rxjs";

export class StageForm {
    fields: FormlyFieldConfig[];

    actionText = 'stages.button.new';

    constructor(translateService, user, config?) {

      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'description',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.description')
              }
          }
      ]
    }    
}

export class EditStageForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, stage, user, config?) {
    // this.model = measurement;

    this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: stage.name,
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name')
        }
      },
      {
        key: 'description',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: stage.description,
        props: {
          required: false
        },
        expressions: {
          'props.label': translateService.stream('fields.description')
        }
      },
    ]
  }
}

export class AdminCreateStageForm {
    fields: FormlyFieldConfig[];

    actionText = 'stages.button.new';

    constructor(translateService, dataProjects, dataCompanies, dataUsers, user, config?) {

      const companies: {value: string | null, label: string}[] = [];
      for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

      const users: {value: string | null, label: string}[] = [];
      for(const user of dataUsers) users.push({value: user['_id'], label: `${user['name']} (${user['email']})` });


      const projects: {value: string | null, label: string}[] = [];
      for(const project of dataProjects) projects.push({value: project['_id'], label: project['name'] });

      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'description',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.description')
              }
          },
          {
              key: 'project',
              type: 'select',
              wrappers: ['default-wrapper'],
              props: {
                options: projects,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.project')
              }
          },
      ];

      if (user.roles.includes('superadmin')) {
        this.fields.push(
          {
              key: 'owner',
              type: 'select',
              wrappers: ['default-wrapper'],
              props: {
                options: users,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.owner')
              }
          },
          {
              key: 'company',
              type: 'select',
              wrappers: ['default-wrapper'],
              props: {
                options: companies,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.company')
              }
          },
        )
      }
    }    
}

export class AdminEditStageForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, currentValue, dataProjects, dataCompanies, dataUsers, user, config?) {
    // this.model = measurement;

    const companies: {value: string | null, label: string}[] = [];
      for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

      const users: {value: string | null, label: string}[] = [];
      for(const user of dataUsers) users.push({value: user['_id'], label: `${user['name']} (${user['email']})` });


      const projects: {value: string | null, label: string}[] = [];
      for(const project of dataProjects) projects.push({value: project['_id'], label: project['name'] });

      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.name,
              props: {
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'description',
              type: 'input',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.description,
              props: {
              required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.description')
              }
          },
          {
              key: 'project',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.project._id,
              props: {
                options: projects,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.project')
              }
          },
      ];

      if (user.roles.includes('superadmin')) {
        this.fields.push(
          {
              key: 'owner',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.owner,
              props: {
                options: users,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.owner')
              }
          },
          {
              key: 'company',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.company,
              props: {
                options: companies,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.company')
              }
          },
        )
      }
  }
}